// PermissionGroupList.tsx
import { Box, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GridColDef } from '@mui/x-data-grid';
import CustomNoRowsOverlay from '@/components/CustomNoRowsOverlay';
import AppDataGrid from '@/components/DataGrid/AppDataGrid';
import { useGetPermissions } from '@/api/permission/permission';
import { PermissionSchema } from '@/zod_schemas';

const customMessage = 'No permission groups available'; // Example custom message

// Define a functional component to use as the overlay
const NoRowsOverlay = () => <CustomNoRowsOverlay message={customMessage} />;

const PermissionGroupList = () => {
  const navigate = useNavigate();
  const { data } = useGetPermissions();
  const columns: GridColDef<PermissionSchema>[] = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      flex: 0.8,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <Button
            variant="outlined"
            size="small"
            onClick={(event) => {
              event.stopPropagation();
              const { id } = params.row;
              navigate(`permission/group/edit/${id}`);
            }}
          >
            Edit
          </Button>
          <Button variant="outlined" color="error" size="small">
            Delete
          </Button>
        </Stack>
      ),
    },
  ];
  return (
    <Box sx={{ width: '100%' }}>
      <AppDataGrid
        rows={data}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        checkboxSelection
        disableRowSelectionOnClick
        slots={{
          noRowsOverlay: NoRowsOverlay,
        }}
        sx={{ border: 0, borderRadius: 0, minHeight: 320 }}
      />
    </Box>
  );
};

export default PermissionGroupList;
